import React from 'react';
import { useLanguage } from '../i18nContext';
import StaticPageLayout from './StaticPageLayout';
import { Shield, Lock, Server, Eye } from 'lucide-react';

interface Props { onBack: () => void; }

export default function SecurityPage({ onBack }: Props) {
  const { language } = useLanguage();
  const en = language === 'en';

  const items = [
    { icon: <Lock size={24} />, title: en ? 'Encryption' : '加密', desc: en ? 'All data is encrypted in transit (TLS 1.3) and at rest (AES-256). Your meeting content is always protected.' : '所有数据在传输（TLS 1.3）和存储（AES-256）时均经过加密。您的会议内容始终受到保护。' },
    { icon: <Server size={24} />, title: en ? 'Infrastructure' : '基础设施', desc: en ? 'Hosted on enterprise-grade cloud infrastructure with 99.9% uptime SLA and automatic failover.' : '托管在企业级云基础设施上，99.9% 正常运行时间 SLA 和自动故障转移。' },
    { icon: <Eye size={24} />, title: en ? 'Access Control' : '访问控制', desc: en ? 'Role-based access control, session management, and anomalous login detection protect your account.' : '基于角色的访问控制、会话管理和异常登录检测保护您的账户。' },
    { icon: <Shield size={24} />, title: en ? 'Compliance' : '合规', desc: en ? 'We follow industry best practices and are committed to maintaining the highest security standards.' : '我们遵循行业最佳实践，致力于维护最高安全标准。' },
  ];

  return (
    <StaticPageLayout title={en ? 'Security' : '安全合规'} onBack={onBack}>
      <div className="text-center mb-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-900/10 mb-6">
          <Shield size={32} className="text-brand-900" />
        </div>
        <h2 className="text-4xl font-bold text-brand-900 font-serif mb-4">
          {en ? 'Security & Compliance' : '安全与合规'}
        </h2>
        <p className="text-lg text-ink-secondary max-w-2xl mx-auto">
          {en ? 'Your data security is our top priority. We implement multiple layers of protection to keep your information safe.' : '您的数据安全是我们的首要任务。我们实施多层保护以确保您的信息安全。'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {items.map((item, i) => (
          <div key={i} className="bg-white rounded-2xl border border-surface-border p-8">
            <div className="text-brand-700 mb-4">{item.icon}</div>
            <h3 className="text-xl font-bold text-brand-900 mb-2">{item.title}</h3>
            <p className="text-ink-secondary">{item.desc}</p>
          </div>
        ))}
      </div>
    </StaticPageLayout>
  );
}
